import { render } from "./QueueEditPage.vue?vue&type=template&id=51404962"
import script from "./QueueEditPage.vue?vue&type=script&lang=js"
export * from "./QueueEditPage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__